module.exports = __webpack_public_path__ + "img/problem2.ce2524a6.png";